import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the type for the slice state
interface MessageState {
  message: string;
}

// Define the initial state using the MessageState type
const initialState: MessageState = {
  message: "",
};

// Create the slice with TypeScript types
const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    clearMessage: (state) => {
      state.message = "";
    },
  },
});

// Export actions and reducer
const { reducer, actions } = messageSlice;
export const { setMessage, clearMessage } = actions;
export default reducer;
